const isDevHost =
  window.location.host.includes("localhost") ||
  window.location.host.includes("dev");

// const DEFAULT_BASE_URL_DEV =
//   "https://asx4tc6j5bwzfr6lvmlyhb5zve0rgbda.lambda-url.ap-south-1.on.aws";
// const DEFAULT_BASE_URL_PROD =
//   "https://wkpfbp5dqrqk24pb4b6vweu4gu0ighki.lambda-url.ap-south-1.on.aws";

const BASE_URL = process.env.REACT_APP_GMB_BASE_URL;
const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

export const GMB = {
  BASE_URL,
  ENDPOINTS: {
    IMAGES: {
      GET_UPLOADED_PRESIGNED_URLS: `${BASE_URL}/get_uploaded_presigned_urls`,
      GET_PRESIGNED_URL_TO_UPLOAD: `${BASE_URL}/get_presigned_url_to_upload`,
      UPLOAD: `${BASE_URL}/upload_gmb`,
      DELETE_PHOTOS: `${BASE_URL}/delete_photos`,
    },
    STORE_MANAGEMENT: {
      GET_ALL_ACCOUNTS: `${BASE_URL}/get_all_accounts`,
      UPDATE_OPEN_STATUS: `${BASE_URL}/update_open_status`,
      UPDATE_LABELS: `${BASE_URL}/update_store_labels`,
      UPDATE_PHONE_NUMBER: `${BASE_URL}/update_store_phone_number`,
      UPDATE_REGULAR_HOURS: `${BASE_URL}/update_regular_hours`,
      UPDATE_TITLE: `${BASE_URL}/update_store_title`,
      TRANSFER_LOC: `${BASE_URL}/transfer_loc`,
    },
    LOCATION_DATA: {
      GET_LOC_DATA: `${BASE_URL}/get_gmb_loc_data`,
      GET_ALL_LOC_DATA: `${BASE_URL}/get_all_gmb_loc_data`,
    },
    VERIFICATION: {
      OPTIONS: `${BASE_URL}/fetch_verification_options`,
      VERIFY: `${BASE_URL}/verify`,
      COMPLETE_VERIFICATION: `${BASE_URL}/complete_verification`,
    },
    POSTS: {
      IMAGES: {
        GET_PRESIGNED_URL_TO_UPLOAD_POSTS: `${BASE_URL}/get_presigned_url_to_upload_posts`,
        UPLOAD_POSTS_TO_S3: `https://gmb-profile-photos.s3.amazonaws.com/`,
        GET_UPLOADED_PRESIGNED_URLS_POSTS: `${BASE_URL}/get_uploaded_presigned_url_posts`,
      },
      GET_ALL_POSTS: `${BASE_URL}/get_all_posts`,
      ADD_EVENT: `${BASE_URL}/add_event_post`,
      ADD_OFFER: `${BASE_URL}/add_offer`,
      ADD_UPDATE: `${BASE_URL}/add_event_post`,
      GET_ACTION_TYPE: `${BASE_URL}/get_action_types`,
      DELETE_POSTS: `${BASE_URL}/delete_post`,
    },
  },
  GOOGLE_MAPS_BASE_URL: GOOGLE_MAP_API_KEY
    ? `https://www.google.com/maps/embed/v1/view?key=${GOOGLE_MAP_API_KEY}`
    : "",
};
